<ca-card *ngIf="modelos?.length > 0">
    <div ca-card-title>{{'AUTOS.BUSCADOR_MODELOS.MODELOS.TITULO' | translate}}</div>
    <div ca-card-content>
        <div class="row col-12 mt-4">
            <ca-radio-group id="modelos-radio-group" name="modelos-radio-group" class="modelos-container" (click)="seleccionarModeloDestacado($event)" >
                    <div *ngFor="let columna of modelosEnColumnas" >
                        <ca-radio-button *ngFor="let modelo of columna" class="columna" [value]="modelo">
                        {{ modelo.nombreModelo }}
                        </ca-radio-button>
                    </div>
            </ca-radio-group>
        </div>
        <div class="row col-4 mt-4">
            <ca-form-field class="form" *ngIf="modelos?.length > 0">
                <ca-label>{{'AUTOS.BUSCADOR_MODELOS.MODELOS.OTROS_MODELOS' | translate}}</ca-label>
                <ca-select 
                    [options]="modelos"
                    keyValue="nombreModelo"
                    valueField="nombreModelo"
                    [placeholder]="'AUTOS.BUSCADOR_MODELOS.MODELOS.OTROS_MODELOS' | translate"
                    formControlName="modelo"
                    virtualScroll
                    (changeValue)="seleccionarModelo($event)"></ca-select>
            </ca-form-field>
        </div>
    </div>
</ca-card>
